import { useTranslation } from 'react-i18next';
import { PropTypes } from '@mui/material';
import FunctionalDialog from 'components/Modals/FunctionalDialog';

type PropTypes = {
  title: string;
  description: string;
  isOpen: boolean;
  onClose: () => void;
  handleDelete: () => void;
};

const ConfirmDeletionModal = ({
  title,
  description,
  isOpen,
  onClose,
  handleDelete,
}: PropTypes) => {
  const { t } = useTranslation();

  return (
    <FunctionalDialog
      title={title}
      description={description}
      state={{
        isOpen,
        isLoading: false,
        error: undefined,
      }}
      action={{
        onSubmit: handleDelete,
        onClose,
        onExited: onClose,
      }}
      closeText={t('library:confirmDeletionModal:cancel')}
      submitText={t('library:confirmDeletionModal:delete')}
      buttonVariant="contained"
      buttonColor="error"
    />
  );
};

export default ConfirmDeletionModal;
